var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "multiselect",
    _vm._b(
      {
        staticClass: "organizations-filter-input",
        attrs: {
          id: _vm.id,
          label: "name",
          "track-by": "id",
          "open-direction": "bottom",
          options: _vm.organizationOptions,
          multiple: true,
          searchable: true,
          loading: _vm.isLoading,
          "internal-search": false,
          "clear-on-select": false,
          "close-on-select": false,
          "options-limit": _vm.optionsMax,
          "limit-text": _vm.organizationFilterTaglimitText,
          "max-height": 600,
          "show-no-results": true,
          "hide-selected": true,
          clear: false,
          "auto-complete": false,
          value: _vm.value
        },
        on: {
          "search-change": _vm.asyncFindOrganizations,
          input: function($event) {
            return _vm.updateValue($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(ref) {
              var values = ref.values
              var search = ref.search
              var isOpen = ref.isOpen
              var remove = ref.remove
              return [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: isOpen,
                        expression: "isOpen"
                      }
                    ]
                  },
                  [
                    _vm._l(_vm.selectedItemTags.slice(0, 5), function(option) {
                      return _c(
                        "span",
                        {
                          staticClass: "custom__tag",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return remove(option)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "item-organization-select" },
                            [_vm._v(_vm._s(option.name))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "multiselect__tag-icon",
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return remove(option)
                              }
                            }
                          })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.selectedItemTags.length - 5 > 0
                      ? _c("div", [
                          _vm._v(
                            " and " +
                              _vm._s(_vm.selectedItemTags.length - 5) +
                              " more organization" +
                              _vm._s(
                                _vm.selectedItemTags.length - 5 > 1 ? "s" : ""
                              ) +
                              " selected.."
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", [
                  values.length && !isOpen
                    ? _c(
                        "span",
                        { staticClass: "multiselect__selected--text" },
                        [
                          _vm._v(
                            _vm._s(_vm.selectedItemTags.length) +
                              " organization" +
                              _vm._s(
                                _vm.selectedItemTags.length > 1 ? "s" : ""
                              ) +
                              " selected"
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            }
          },
          {
            key: "beforeList",
            fn: function(props) {
              return _c("div", {}, [
                _vm.value.length
                  ? _c(
                      "div",
                      {
                        staticClass: "organization-filter__clear",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.clearAllOrganizationFilterTags($event)
                          }
                        }
                      },
                      [_vm._v("Clear selected items")]
                    )
                  : _vm._e()
              ])
            }
          },
          {
            key: "afterList",
            fn: function(props) {
              return _c("div", {}, [
                !_vm.isLoading && !_vm.noMoreOptions
                  ? _c(
                      "div",
                      {
                        staticClass: "organization-filter__load-more",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.asyncLoadMoreOrganizationFilterItems(
                              $event
                            )
                          }
                        }
                      },
                      [_vm._v("\n      Load more items\n    ")]
                    )
                  : _vm._e()
              ])
            }
          }
        ])
      },
      "multiselect",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
        _vm._v("No items matching query.")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }